import React, { useState, useEffect, useRef } from "react";
import { Modal, Tabs, Tab } from "react-bootstrap";
import {
  Button,
  Col,
  Row,
  Form,
  InputGroup,
  FormControl,
  FloatingLabel,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import PagingNav from "../component/PagingNav";
import { getUserSession } from "../component/userInfo";
import Image from "react-bootstrap/Image";

import "./ReadingBible.css";

const ReadingBible = () => {
  const [paging, setPaging] = useState();
  const [rb90List, setRb90List] = useState([]);
  const [rbjesusList, setRbjesusList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [column, setColumn] = useState("all");
  const [modal90Show, setModal90Show] = useState(false);

  const modal90Close = () => setModal90Show(false);
  const modal90Open = () => setModal90Show(true);
  const [fdate, setFdate] = useState("");
  const [tdate, setTdate] = useState("");

  // --- 조회 기능용 상태 변수 추가 ---
  const [perpage, setPerpage] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [tempKeyword, setTempKeyword] = useState("");
  const [activeTab, setActiveTab] = useState("rb90");

  useEffect(() => {
    fetchMainList(1); // 새 조회 시 1페이지부터 시작
  }, [keyword, perpage, activeTab]);

  const fetchMainList = async (page) => {
    const userSession = getUserSession();
    try {
      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append(
        "action",
        activeTab === "rb90" ? "rb90_list" : "rbjesus_list"
      );
      formData.append("perpage", perpage); // 페이지 당 항목 수
      if (page) formData.append("page", page);
      if (keyword) {
        formData.append("keyword", keyword);
        formData.append("column", column);
      }

      let res = await fetch("https://work.wekoinonia.org/json/rbjesus.php", {
        method: "POST",
        body: formData,
      });

      let json = await res.json(); //Promise 반환
      console.log(json); // 서버에서 주는 json데이터가 출력 됨
      if (json.paging) {
        setPaging(json.paging);
      } else {
        setPaging(null);
      }
      if (activeTab === "rb90") {
        if (json.rb90) {
          setRb90List(json.rb90);
        } else {
          setRb90List([]);
        }
        setRbjesusList([]);
      } else {
        if (json.rbjesus) {
          setRbjesusList(json.rbjesus);
        } else {
          setRbjesusList([]);
        }
        setRb90List([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const getPage = (page) => {
    console.log("page = ", page);
    fetchMainList(page);
  };

  // --- 조회 핸들러 함수 추가 ---
  const handleSearch = () => {
    if (keyword !== tempKeyword) {
      setKeyword(tempKeyword);
    }
  };

  const handlePerpageChange = (e) => {
    setPerpage(parseInt(e.target.value, 10));
  };

  const handleTabSelect = (key) => {
    setActiveTab(key);
    setPaging(null);
    // fetchMainList(1);
  };

  const selectItem = ({ target }) => {
    console.log(target);
    console.log(target.checked, target.value);

    if (target.checked) {
      let newSelectedList = selectedList.concat(target.value);
      setSelectedList(newSelectedList);
      console.log(selectedList);
    } else {
      let newSelectedList = selectedList.filter(
        (selected) => selected !== target.value
      );
      console.log(newSelectedList);
      setSelectedList(newSelectedList);
      console.log(selectedList);
    }
  };
  const changeFdate = (e) => {
    setFdate(e.target.value);
    console.log(fdate);
  };
  return (
    <div id="content">
      {" "}
      {/* https://startbootstrap.com/previews/sb-admin 참조*/}
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Page Heading */}
        <h1 className="h3 mb-2 text-gray-800">
          리딩바이블 & 90일 성경읽기 일정관리
        </h1>
        <p className="mb-4"></p>

        {/* DataTales Example */}
        <div className="card shadow mb-4">
          <div className="card-body">
            <div>
              {/* className="table-responsive" 이게 하단 스크롤바가 생기게 만들어서 */}
              <div
                id="dataTable_wrapper"
                className="dataTables_wrapper dt-bootstrap4"
              >
                <div className="dataTable-top">
                  <div className="dataTable-dropdown">
                    <label>
                      <select
                        className="dataTable-selector"
                        value={perpage}
                        onChange={handlePerpageChange}
                      >
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="20">20</option>
                        <option value="25">25</option>
                      </select>
                    </label>
                  </div>
                  <div className="dataTable-search">
                    <InputGroup>
                      <FormControl
                        className="dataTable-input"
                        placeholder="제목, 내용으로 조회"
                        value={tempKeyword}
                        onChange={(e) => setTempKeyword(e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                      />
                      <Button variant="primary" onClick={handleSearch}>
                        조회
                      </Button>
                    </InputGroup>
                  </div>
                </div>
                <Tabs
                  activeKey={activeTab}
                  onSelect={handleTabSelect}
                  id="controlled-tab-example"
                  className="mb-3"
                >
                  <Tab eventKey="rb90" title="90일성경읽기">
                    <div className="row">
                      <div className="col-sm-12">
                        <table
                          className="table table-bordered dataTable"
                          id="dataTable"
                          width="100%"
                          cellSpacing="0"
                          role="grid"
                          aria-describedby="dataTable_info"
                          style={{ width: "100%" }}
                        >
                          <thead>
                            <tr role="row">
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="dataTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="제목: activate to sort column ascending"
                                style={{ width: "auto" }}
                              >
                                제목
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="dataTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="내용: activate to sort column ascending"
                                style={{ width: "auto" }}
                              >
                                내용
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="dataTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="시작일: activate to sort column ascending"
                                style={{ width: "10rem" }}
                              >
                                시작일
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="dataTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="종료일: activate to sort column ascending"
                                style={{ width: "10rem" }}
                              >
                                종료일
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="dataTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="사용여부: activate to sort column ascending"
                                style={{ width: "4rem" }}
                              >
                                상태
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {rb90List.map((item, index) => {
                              const url = `/ReadingBible90`;
                              return (
                                <tr key={index}>
                                  <td>
                                    <Link
                                      to={url}
                                      state={{ bible: item, action: "update" }}
                                    >
                                      {item.rb90_title}
                                    </Link>
                                  </td>
                                  <td>{item.rb90_content}</td>
                                  <td>{item.fdate}</td>
                                  <td>{item.tdate}</td>
                                  <td>{item.use_yn != "Y" ? "미사용" : ""}</td>
                                </tr>
                              );
                            })}
                            {rb90List.length === 0 && (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  {" "}
                                  해당 데이터가 없습니다.{" "}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <Row>
                      <Col className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          type="button"
                          style={{ width: "16rem" }}
                          onClick={modal90Open}
                        >
                          90일성경읽기 신규생성
                        </Button>
                        <Modal show={modal90Show} onHide={modal90Close}>
                          <Modal.Header closeButton>
                            <Modal.Title> 90일 성경읽기 신규등록 </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <InputGroup className="content-border mb-3">
                              <FloatingLabel
                                controlId="publish_plan"
                                label="시작일자"
                              >
                                <Form.Control
                                  type="date"
                                  placeholder="시작일"
                                  value={fdate}
                                  onChange={changeFdate}
                                  style={{
                                    width: "auto",
                                    border: "0px solid #ffffff",
                                  }}
                                />
                              </FloatingLabel>
                            </InputGroup>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button variant="secondary" onClick={modal90Close}>
                              닫기
                            </Button>
                            <Link
                              to={`/ReadingBible90`}
                              state={{
                                bible: { rb90_no: "0", fdate: fdate },
                                action: "insert",
                              }}
                            >
                              <Button variant="primary">신규 생성</Button>
                            </Link>
                          </Modal.Footer>
                        </Modal>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="rjesus" title="리딩지저스">
                    <div className="row">
                      <div className="col-sm-12">
                        <table
                          className="table table-bordered dataTable"
                          id="dataTable"
                          width="100%"
                          cellSpacing="0"
                          role="grid"
                          aria-describedby="dataTable_info"
                          style={{ width: "100%" }}
                        >
                          <thead>
                            <tr role="row">
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="dataTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="제목: activate to sort column ascending"
                                style={{ width: "auto" }}
                              >
                                제목
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="dataTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="내용: activate to sort column ascending"
                                style={{ width: "auto" }}
                              >
                                내용
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="dataTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="시작일: activate to sort column ascending"
                                style={{ width: "10rem" }}
                              >
                                시작일
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="dataTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="종료일: activate to sort column ascending"
                                style={{ width: "10rem" }}
                              >
                                종료일
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="dataTable"
                                rowSpan="1"
                                colSpan="1"
                                aria-label="사용여부: activate to sort column ascending"
                                style={{ width: "4rem" }}
                              >
                                상태
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {rbjesusList.map((item, index) => {
                              const url = `/ReadingBibeJesus`;
                              return (
                                <tr key={index}>
                                  <td>
                                    <Link to={url} state={{ bible: item }}>
                                      {item.rbjesus_title}
                                    </Link>
                                  </td>
                                  <td>
                                    {item.year}년 {item.rbjesus_content}
                                  </td>
                                  <td>{item.fdate}</td>
                                  <td>{item.tdate}</td>
                                  <td>{item.use_yn != "Y" ? "미사용" : ""}</td>
                                </tr>
                              );
                            })}
                            {rbjesusList.length === 0 && (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  {" "}
                                  해당 데이터가 없습니다.{" "}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
                <Row>
                  <Col lg={12} className="mx-auto">
                    <PagingNav paging={paging} callback={getPage} />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*.container-fluid */}
    </div>
  );
};

export default ReadingBible;
